module.exports = __webpack_public_path__ + "static/kumadex-jlpt-n4-25-words-2c0d1c15a88542d920dfd63d211d4c3a.png";